module.exports = __webpack_public_path__ + "static/media/home.56552af3.svg";